import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import { getProffesionalTitle } from "../util/helpers";
import { useIntl } from "react-intl";
const { Text } = Typography;

const ProffesionalTitle = (props) => {
  const { record } = props;
  const [name, setName] = useState([]);
  const intl = useIntl();
  useEffect(() => {
    if (record) {
      setName(getProffesionalTitle(record, intl));
    }
  }, [intl, record]);
  return <Text>{name}</Text>;
};

export default ProffesionalTitle;
